<span [innerHTML]="jhiTranslate | translate:translateValues"></span>


// WEBPACK FOOTER //
// ./~/ng-jhipster/src/language/jhi-translate.directive.d.ts.JhiTranslateComponent.html